import React from "react";
import { useTranslation } from "react-i18next";

export const currencyOptions = [
    { code: "USD", label: "USD ($)", flag: "/flags/us.svg" },
    { code: "RUB", label: "RUB (₽)", flag: "/flags/ru.svg" },
    { code: "BRL", label: "BRL (R$)", flag: "/flags/br.svg" },
    { code: "EUR", label: "EUR (€)", flag: "/flags/eu.svg" },
];

const CurrencyDropdown = ({
    currentCurrency,
    onSelect,
    onClose,
    style
}) => {
    const { t } = useTranslation();

    // Символ валюты
    const getCurrencySymbol = (currency) => {
        switch (currency) {
            case 'USD': return '$';
            case 'RUB': return '₽';
            case 'BRL': return 'R$';
            case 'USDT': return '₮';
            case 'EUR': return '€';
            default: return '';
        }
    };

    return (
        <div
            className="sidebar-balance-dropdown-list"
            style={{
                position: 'relative',
                transform: 'none',
                left: 'auto',
                right: 'auto',
                top: 'auto',
                ...style
            }}
        >
            <div className="sidebar-balance-dropdown-header">
                <span>{t('Выберите валюту')}</span>
                <button className="sidebar-balance-dropdown-close" onClick={onClose} aria-label="Закрыть">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#23232e" />
                        <path d="M16 8L8 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        <path d="M8 8L16 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>
            </div>
            <div className="sidebar-balance-dropdown-scroll">
                {currencyOptions.map((option) => (
                    <div
                        key={option.code}
                        className={`sidebar-balance-dropdown-item${option.code === currentCurrency ? ' selected' : ''}`}
                        onClick={() => onSelect(option.code)}
                    >
                        <img src={option.flag} alt={option.code} className="sidebar-balance-flag" />
                        <span>{option.label.split(' ')[0]}</span>
                        <span className="sidebar-balance-currency-symbol">{getCurrencySymbol(option.code)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CurrencyDropdown;
